import type React from "react";

interface LayoutProps {
  children: React.ReactNode;
}

/**
 * Layout principal de l'application
 * Structure générale de l'application
 */
const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <div className="min-h-screen">
      <main className="flex-1">{children}</main>
    </div>
  );
};

export default Layout;
